import styled from '@emotion/styled';
import { breakpointSmall } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';

export const Table = styled.table`
  border: 1px solid ${colors.lightGrey2};
  border-collapse: collapse;
  font-size: 14px;
`;

export const THead = styled.thead`
  background-color: ${colors.whiteGrey2};
  font-weight: 500;
`;

export const Td = styled.td<{ width?: string, alignLeft?: boolean }>`
width: ${({ width }) => width};
padding: 14px 25px;
border: 1px solid ${colors.lightGrey2};
text-align: ${({ alignLeft }) => alignLeft ? 'left' : 'center'};
word-break: keep-all;

@media (max-width: ${breakpointSmall}) {
  padding: 14px 15px;
  font-size: 12px;
}
`;
